<template>
  <div class="cover"
       @click.self="closePlay">
    <div class="video_panel">
      <div class="videoBox">
        <video ref="video" controls :src="videoUrl" @ended="videoEnd()"></video>
        <div class="close_btn" @click="closePlay">
          <img class="closeTuiImg" src="./img/img_icon_10.png"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import {ref, inject, onMounted} from "vue"

const emit = defineEmits(['popClose'])
let video = ref()
let videoUrl = "https://jindouyuan202105.oss-cn-beijing.aliyuncs.com/ad/huihuaxinshoujiaocheng.mp4"

function show() {

}

function closePlay() {
  video.value.pause();
  console.log("closePlay==closePlay")
  emit('popClose')
}

function playVideo() {
  video.value.play();
}

function videoEnd() {

}

defineExpose({show,playVideo})
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.cover {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  .video_panel {
    width: calc(100% - 80px);
    height: auto;
    border:5px solid #ffffff;

    .videoBox {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;

      video {
        width: 100%;
        height: auto;
      }

      .close_btn {
        position: absolute;
        bottom: -40px;
        left: 50%;
        transform: translate(-50%);
        width: 26px;
        height: 26px;
        cursor: pointer;
        border-radius: 50%;
        background: #ffffff;
        display: flex;
        justify-content: center;
        align-items: center;

        .closeTuiImg {
          width: 15px;
          height: 15px;
        }
      }
    }
  }
}
</style>